
















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { quickscanConfig } from '@config';
import { PopupMixin } from '@mixin';
import PageMain from '@part/layout/PageMain.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        PageMain,
    },

    mixins: [
        PopupMixin,
    ],

    mounted() {
        this.$root.$emit('root::layout::hideFooter', true);
    },

    beforeDestroy() {
        this.$root.$emit('root::layout::hideFooter', false);
    },

    computed: {
        progress() {
            return this.$route.params.step / (quickscanConfig.length - 1);
        },
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Quickscan extends Vue {}

